
import { Badge } from "@/components/ui/badge"
import { PlanTier } from '@/lib/types'

interface LicensePlanBadgeProps {
  plan: PlanTier
}

export function LicensePlanBadge({ plan }: LicensePlanBadgeProps) {
  const variants: Record<string, string> = {
    enterprise: "bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300 border-purple-200 dark:border-purple-800",
    professional: "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300 border-blue-200 dark:border-blue-800",
    starter: "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300 border-slate-200 dark:border-slate-700",
  }

  return (
    <Badge variant="outline" className={`capitalize font-normal ${variants[plan] || variants.starter}`}>
      {plan}
    </Badge>
  )
}
